import { StyledProps } from 'styled-components';

export const getSpace = (units: number) => {
  return (props: StyledProps<unknown>): string => `${props.theme.space[units] || units}px`;
};
